"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import type { SortDirection } from "@/entities/ISort";
import { RepsTableSort } from "./UserPageRepRepsTable";
import UserPageRepRepsTableHeaderSortableCell from "./UserPageRepRepsTableHeaderSortableCell";
export default function UserPageRepRepsTableHeader(t0) {
  const $ = _c(17);
  const {
    activeType,
    sortDirection,
    showMyRates,
    onSortTypeClick
  } = t0;
  const getTypes = _temp;
  let t1;
  if ($[0] !== showMyRates) {
    t1 = getTypes(showMyRates);
    $[0] = showMyRates;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [types, setTypes] = useState(t1);
  let t2;
  let t3;
  if ($[2] !== showMyRates) {
    t2 = () => setTypes(getTypes(showMyRates));
    t3 = [showMyRates];
    $[2] = showMyRates;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <th scope="col" className="tw-whitespace-nowrap tw-px-4 sm:tw-px-6 tw-py-3 tw-text-left tw-text-sm sm:tw-text-md tw-font-medium tw-text-iron-400">Category</th>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== activeType || $[7] !== onSortTypeClick || $[8] !== sortDirection || $[9] !== types) {
    let t6;
    if ($[11] !== activeType || $[12] !== onSortTypeClick || $[13] !== sortDirection) {
      t6 = sortType => <UserPageRepRepsTableHeaderSortableCell key={sortType} type={sortType} activeType={activeType} activeDirection={sortDirection} onSortTypeClick={onSortTypeClick} />;
      $[11] = activeType;
      $[12] = onSortTypeClick;
      $[13] = sortDirection;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    t5 = types.map(t6);
    $[6] = activeType;
    $[7] = onSortTypeClick;
    $[8] = sortDirection;
    $[9] = types;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[15] !== t5) {
    t6 = <thead className="tw-bg-iron-950 tw-border-b tw-border-x-0 tw-border-t-0 tw-border-white/10"><tr>{t4}{t5}</tr></thead>;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}
function _temp(myRates) {
  if (myRates) {
    return [RepsTableSort.REP, RepsTableSort.RATERS, RepsTableSort.MY_RATES];
  }
  return [RepsTableSort.REP, RepsTableSort.RATERS];
}